// components/TableRemitosc.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Table } from "react-bootstrap";
import {
  getRemitocs,
  deleteRemitoc,
  getRemitocById,
} from "../helpers/rutaRemitocs";
import ModalRemitoc from "./ModalFormRemitoc";

const COLS = {
  acciones: 100, nro: 90, fecha: 120,
  hora: 90,           // 👈 NUEVO
  kg: 110, precio: 120,
  persona: 220, // proveedor/cliente/transporte/chofer/cliente real
  variedad: 180,
  money: 140, dtv: 160,
  lote: 160,
  nota: 220,
  estado: 180, observa: 220,
  remint: 160, factura: 160,
  bool: 80,
};
const trunc = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const fmtDate  = (d) => (d ? new Date(d).toLocaleDateString("es-AR") : "-");
const fmtMoney = (n) => Number(n || 0).toLocaleString("es-AR", { minimumFractionDigits: 2 });

const TableRemitosc = () => {
  const [state, setState] = useState({ remitocs: [], loading: true, error: "" });
  const [remitocSel, setRemitocSel] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => { load(); }, []);
  const load = async () => {
    try {
      const list = await getRemitocs();
      const arr = Array.isArray(list) ? list : (list?.remitosc || []);
      arr.sort((a,b) => (b.codrem||0) - (a.codrem||0) || new Date(b.fecha) - new Date(a.fecha));
      setState({ remitocs: arr, loading: false, error: "" });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e?.message || "Error al cargar Remitos C" }));
    }
  };

  const handleCloseEdit = useCallback(() => {
    setShowEdit(false);
    setRemitocSel(null);
    setTimeout(() => load(), 0);
  }, []);

  const onEdit = async (id) => {
    try {
      setShowEdit(true);
      setRemitocSel(null);
      const resp = await getRemitocById(id);
      if (resp?.ok) setRemitocSel(resp.remitoc);
      else console.error("❌ getRemitocById:", resp?.error || resp);
    } catch (e) {
      console.error(e);
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("¿Borrar (lógico) este Remito C?")) return;
    try { await deleteRemitoc(id); load(); } catch (e) { console.error(e); }
  };

  if (state.loading) return <div className="p-3">Cargando Remitos C…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  return (
    <div className="table-container">
      <div className="d-flex justify-content-between align-items-center my-3">
        <h5 className="m-0">Gestión de Remitos C</h5>
      </div>

      <Table striped bordered hover style={{ tableLayout: "fixed", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: COLS.acciones }}>Acciones</th>
            <th style={{ width: COLS.bool }}>Tilde</th>
            <th style={{ width: COLS.bool }}>Color</th>
            <th style={{ width: COLS.nro }}>Remito</th>
            <th style={{ width: COLS.fecha }}>Fecha</th>
            <th style={{ width: COLS.hora }}>Hora</th>   {/* 👈 NUEVO */}
            <th style={{ width: COLS.persona }}>Proveedor</th>
            <th style={{ width: COLS.persona }}>Cliente</th>
            <th style={{ width: COLS.persona }}>Cliente Real</th>
            <th style={{ width: COLS.kg }}>KG Campo</th>
            <th style={{ width: COLS.kg }}>KG Recibidos</th>
            <th style={{ width: COLS.kg }}>Diferencia</th>
            <th style={{ width: COLS.precio }}>Precio Compra</th>
            <th style={{ width: COLS.precio }}>Precio Venta</th>
            <th style={{ width: COLS.persona }}>Transporte</th>
            <th style={{ width: COLS.persona }}>Chofer</th>
            <th style={{ width: COLS.lote }}>Lote</th>
            <th style={{ width: COLS.variedad }}>Variedad</th>
            <th style={{ width: COLS.money }}>Total Compra</th>
            <th style={{ width: COLS.money }}>Total Venta</th>
            <th style={{ width: COLS.money }}>Comisión</th>
            <th style={{ width: COLS.dtv }}>Nro DTV Compra</th>
            <th style={{ width: COLS.dtv }}>Nro DTV Venta</th>
            {/* Campos extra RemitoC */}
            <th style={{ width: COLS.remint }}>Remito Interno</th>
            <th style={{ width: COLS.estado }}>Estado</th>
            <th style={{ width: COLS.observa }}>Observación</th>
            <th style={{ width: COLS.factura }}>Factura Compra</th>
            <th style={{ width: COLS.factura }}>Factura Venta</th>

            <th style={{ width: COLS.nota }}>Notas</th>
          </tr>
        </thead>
        <tbody>
          {state.remitocs.length === 0 ? (
            <tr><td colSpan={30} className="text-center">No hay Remitos C.</td></tr>
          ) : state.remitocs.map((r) => (
            <tr key={r._id}>
              <td style={{ whiteSpace: "nowrap" }}>
                <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                  <button className="btn btn-primary" onClick={() => onEdit(r._id)}>
                    <i className="fa fa-pencil-square-o" />
                  </button>
                  <button className="btn btn-danger" onClick={() => onDelete(r._id)}>
                    <i className="fa fa-trash-o" />
                  </button>
                </div>
              </td>
              <td style={{ textAlign: "center" }}>{r.tilde ? "✅" : "—"}</td>
              <td style={{ textAlign: "center" }}>{r.color ? "✅" : "—"}</td>
              <td>{r.codrem}</td>
              <td>{fmtDate(r.fecha)}</td>
              <td>{r.horaCarga || "-"}</td>    {/* 👈 NUEVO */}
              <td style={trunc}>{r.proveedor?.razonsocial || "-"}</td>
              <td style={trunc}>{r.cliente?.razonsocial || "-"}</td>
              <td style={trunc}>{r.clientereal?.razonsocial || "-"}</td>
              <td>{r.kgCampo}</td>
              <td>{r.kgRecibido}</td>
              <td>{r.diferencia}</td>
              <td>{fmtMoney(r.precioCompra)}</td>
              <td>{fmtMoney(r.precioVenta)}</td>
              <td style={trunc}>{r.transporte?.transporte || "-"}</td>
              <td style={trunc}>{r.chofer?.nombre || "-"}</td>
              <td style={{ ...trunc, textAlign: "left" }}>
                {r.lote
                  ? (r.lote.codlote != null ? `#${r.lote.codlote} - ${r.lote.lote}` : r.lote.lote)
                  : "-"
                }
              </td>
              <td style={trunc}>{r.variedad || "-"}</td>
              <td>{fmtMoney(r.totalCompra)}</td>
              <td>{fmtMoney(r.totalVenta)}</td>
              <td>{fmtMoney(r.comision)}</td>
              <td style={trunc}>{r.nroDTVCompra || "-"}</td>
              <td style={trunc}>{r.nroDTVVenta || "-"}</td>

              {/* Extra RemitoC */}
              <td style={trunc}>{r.remitoint || "-"}</td>
              <td style={trunc}>{r.estado?.estado || "-"}</td>
              <td style={trunc}>{r.observa?.observa || "-"}</td>
              <td style={trunc}>{r.factcompra || "-"}</td>
              <td style={trunc}>{r.factventa || "-"}</td>


              <td style={trunc}>{r.nota || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ModalRemitoc
        show={showEdit}
        remitoc={remitocSel}
        onClose={handleCloseEdit}
      />
    </div>
  );
};

export default TableRemitosc;
